<template>   
<div>     <!-- 试用申请提示 -->     
<el-dialog class="try-dialog" :visible.sync="tryStateDialog" width="480px" :close-on-click-modal="false" :close-on-press-escape="false"  >       <!-- 认证教师 -->       <template v-if="applyCheckStatus === 'NOT_TEACHER'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/warning.png" />           <p class="desc">需认证为教师后才可申请免费教材试用</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_tryStateDialog "  @click="tryStateDialog = false" class="close">取消 
</el-button>           
<el-button autoId="btn_toCertification"  type="primary" @click="toCertification">立即认证 
</el-button>         
</div>       </template>       <!-- 教材试用上线 -->       <template v-if="applyCheckStatus === 'OVER'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/warning.png" />           <p class="desc">今年您申请的教材试用已达上限</p>           <p class="record" @click="toSampleApply">查看我的申请记录</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_tryStateDialog "  type="primary" @click="tryStateDialog = false">好的 
</el-button>         
</div>       </template>       <!-- 已有此书 -->       <template v-if="applyCheckStatus === 'HAS'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/warning.png" />           <p class="desc">您已有此书，无需申请试用</p>           <p class="record" @click="toList">查看我的书架</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_tryStateDialog "  type="primary" @click="tryStateDialog = false">好的 
</el-button>         
</div>       </template>       <!-- 申请已在审核中 -->       <template v-if="applyCheckStatus === 'EXIST'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/warning.png" />           <p class="desc">您的试用申请已在审核中，请耐心等待</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_tryStateDialog "  type="primary" @click="tryStateDialog = false">好的 
</el-button>         
</div>       </template>       <!-- 自动审核 -->       <template v-if="isAutoORWait === 'AUDIT_PASS'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/success.png" />           <p class="desc">申请通过</p>           <p class="desc-text">已将该书自动加入您的书架</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_triggerRefresh"  @click="triggerRefresh()" class="close">关闭 
</el-button>           
<el-button autoId="btn_preview"  type="primary" @click="preview">打开教材 
</el-button>         
</div>       </template>       <!-- 等待审核 -->       <template v-if="isAutoORWait === 'AUDITING'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/success.png" />           <p class="desc">提交成功，等待审核</p>           <p class="desc-text">申请结果将通过系统通知发送给您</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_tryStateDialog "  type="primary" @click="tryStateDialog = false;isAutoORWait = ''">好的 
</el-button>         
</div>       </template>       <!-- 教师认证审核中 -->       <template v-if="applyCheckStatus === 'AUDITING'">         
<div class="try-detail">           <img class="try-type" src="@/assets/images/warning.png" />           <p class="desc">教师认证信息审核中，请等待审核通过后再发起试用申请</p>         
</div>         
<div slot="footer" class="dialog-footer">           
<el-button autoId="btn_tryStateDialog "  type="primary" @click="tryStateDialog = false">好的 
</el-button>         
</div>       </template>     
</el-dialog>      <!-- 教师试用 -->     
<el-dialog class="try-form-dialog"  :visible.sync="tryFormDialog" width="600px" title="教师试用" :close-on-click-modal="false" :close-on-press-escape="false"  >       
<div class="book-detail">         
<div class="cover-div">           <img class="cover" :src="detail && detail.cover || require('@/assets/images/no_cover.svg')" />         
</div>         
<div class="cover-info">           <h2>{{ detail && detail.title }}</h2>           <h3>申请试用时间             <span :class="[selectTime === i.code ? 'select' : '']"               v-for="i in sampleDetail.times"               :key="i.code"               @click="changeSelectTime(i)"             >{{ i.value }}</span>           </h3>         
</div>       
</div>       
<div class="tip-desc">         <h4><img class="try-type" src="@/assets/images/warning.png" />温馨提示</h4>         <p>1.每年可免费申请 {{ sampleDetail.amount }} 本数字教材试用<span class="book-record" @click="toSampleApply" v-if="reApplyVal">查看我的申请记录</span></p>         <p>2.申请通过后生效，{{ selectTimeName }}到期。到期后无法使用，需购买或激活后继续使用</p>         <p v-if="tipShow">3.申请成功后，您可阅读教材或使用教材授课。如果您使用此教材新建班级并有学生加入学习，为了保证您的教学过程完整，此教材试用有效期将延长至一年。</p>       
</div>       
<div slot="footer" class="dialog-footer">         
<el-button autoId="btn_tryFormDialog "  @click="tryFormDialog = false" class="close">取消 
</el-button>         
<el-button autoId="btn_handleSubmit"  type="primary" @click="handleSubmit">提交申请 
</el-button>       
</div>     
</el-dialog>   
</div> </template>
<script>
import {
  sampleBookCheck,
  sampleBookDays,
  sampleBookApply
} from "@/api/book";
import { getPosition } from "@/api/reader";
export default {
  name: 'SampleBookApply',
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    bookId: {
      type: String,
      default: ''
    },
    reApplyVal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo || {}
    },
  },
  data() {
    return {
      tryStateDialog: false,
      tryFormDialog: false,
      applyCheckStatus: '',
      isAutoORWait: '',
      sampleDetail: {},
      selectTime: '',
      selectTimeName: '',
      tipShow: false,
    };
  },
  methods: {
    applyCheck() {
      const params = {
        bookId: this.bookId,
      }
      sampleBookCheck(params).then((res) => {
        if (res.code === 200) {
          this.applyCheckStatus = res.data;
          if (this.applyCheckStatus !== 'SUCCESS') {
            this.tryStateDialog = true;
          } else {
            this.getSampleBookDays();
          }
        }
      })
    },
    getSampleBookDays(){
      sampleBookDays().then((res) => {
        if (res.code === 200) {
          this.tryFormDialog = true;
          this.sampleDetail = res.data
          this.selectTime = this.sampleDetail && this.sampleDetail.times.length>0 && this.sampleDetail.times[0].code;
          this.selectTimeName = this.sampleDetail && this.sampleDetail.times.length>0 && this.sampleDetail.times[0].value;
          this.tipShow = this.selectTime.includes('Y') ? false : true;
        }
      })
    },
    changeSelectTime(value) {
      this.selectTime = value.code;
      this.selectTimeName = value.value;
      this.tipShow = value.code.includes('Y') ? false : true;
    },
    toCertification() {
      this.$router.push({name: 'Person', query: { bookId: this.bookId, title: this.detail.title }})
      localStorage.setItem('activeName', 'first')
    },
    toList() {
      this.$router.push({name: 'List', query: {parentId: 'list'}})
    },
    toSampleApply() {
      if (!this.reApplyVal) {
        this.tryStateDialog = false
      }
      this.$router.push({name: 'SampleBook'})
    },
    handleSubmit() {
      const params = {
        bookId: this.bookId,
        collegeId: this.userInfo.collegeId,
        userId: this.userInfo.userId,
        validityPeriod: this.selectTime
      }
      sampleBookApply(params).then((res) => {
        if (res.code === 200) {
          this.tryFormDialog = false;
          this.tryStateDialog = true;
          this.isAutoORWait = res.data;
          this.$emit('refreshBook')
        }
      })
    },
    /** 打开教材 */
    async preview() {
      const res = await getPosition(this.detail.editorBookId)
      let sectionId;
      if(res && res.data){
        sectionId = res.data.sectionId
      }
      if (this.detail.editorBookId && sectionId) {
        this.$router.push({
          path: `/bookPreview?bookId=${this.detail.editorBookId}&chapterId=${sectionId}`,
        });
      }
    },
    triggerRefresh() {
      this.tryStateDialog = false
      this.isAutoORWait = ''
      this.$emit('refresh-parent')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep.try-dialog{
  font-family: PingFang SC, PingFang SC;
  text-align: center;
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-dialog__footer {
    padding: 13px 16px;
    border-color: #F0F0F0;
  }
  .el-button{
    font-size: 14px;
    line-height: 22px;
    padding: 5px 16px;
  }
  .try-type{
    width: 48px;
    height: 48px;
    margin: 20px 0 16px 0;
  }
  .desc{
    font-weight: 500;
    font-size: 16px;
    color: #3E4D71;
    line-height: 22px;
    margin: 0;
  }
  .record{
    font-weight: 500;
    font-size: 16px;
    color: var(--color);
    line-height: 22px;
    margin: 16px 0 0;
    cursor: pointer;
  }
  .close{
    border: 1px solid var(--color);
    color: var(--color);
  }
  .desc-text{
    font-size: 14px;
    color: #78839C;
    line-height: 22px;
    margin-top: 8px;
  }
}
::v-deep.try-form-dialog{
  font-family: PingFang SC, PingFang SC;
  font-size: 14px;
  .el-dialog__header{
    border-color: #F0F0F0;
    padding: 13px 20px;
    .el-dialog__title{
      font-size: 16px;
      color: #3E4D71;
      line-height: 22px;
      font-weight: 500;
    }
    .el-dialog__close{
      font-size: 18px;
    }
  }
  .el-dialog__body{
    padding:16px 24px 44px;
  }
  .el-dialog__footer {
    padding: 13px 16px;
    border-color: #F0F0F0;
  }
  .el-button{
    font-size: 14px;
    line-height: 22px;
    padding: 5px 16px;
  }
  .book-detail{
    display: flex;
    align-items: center;
    background: #F5F7F9;
    border-radius: 8px 8px 8px 8px;
    padding: 24px;
    .cover {
      width: 72px;
      height: 96px;
    }
    .cover-info{
      margin-left: 23px;
      h2{
        font-weight: 500;
        font-size: 18px;
        color: #3E4D71;
        line-height: 21px;
      }
      h3{
        color: #3E4D71;
        line-height: 16px;
        font-size: 14px;
        span{
          padding: 2px 12px;
          border-radius: 4px 4px 4px 4px;
          line-height: 24px;
          margin-left: 16px;
          cursor: pointer;
        }
        .select{
          background: #DDE6FE;
          color: var(--color);
        }
      }
    }
  }
  .tip-desc{
    margin-top: 24px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #F5F7F9;
    padding: 24px;
    img{
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    h4{
      color: #3E4D71;
      line-height: 16px;
      display: flex;
      align-items: center;
    }
    p{
      color: #78839C;
      line-height: 20px;
      margin: 12px 0 0;
      .book-record{
        cursor: pointer;
        margin-left: 24px;
        color: var(--color);
      }
    }
  }
  .close{
    border: 1px solid var(--color);
    color: var(--color);
  }
}
</style>
